import app from 'flarum/forum/app';
import chatState from '../state/chat';

/**
 * Resposta a convites de canal, compartilhada pela notificação, pelo composer do
 * canal público convidado, pelo card de navegação e pelo menu do canal.
 *
 * Aceitar usa a rota de convite, não `join`: canal privado não é visível para quem
 * não entrou, então o endpoint de join nunca o encontraria.
 */

/**
 * Aceita e devolve o canal como o servidor o serializa agora, ou null se o
 * convite já não estava aberto. O registro já traz `canPostMessage` e as demais
 * flags, então o composer aparece sem recarregar.
 */
export async function acceptInvitation(channelId) {
  const payload = await app.request({
    method: 'POST',
    url: "".concat(app.forum.attribute('apiUrl'), "/chat/invites/").concat(channelId, "/accept")
  });
  const channel = adoptChannelPayload(payload);
  if (channel) chatState.rememberChannel(channel);
  return channel;
}
export async function declineInvitation(channelId) {
  await app.request({
    method: 'POST',
    url: "".concat(app.forum.attribute('apiUrl'), "/chat/invites/").concat(channelId, "/decline")
  });
  const channel = chatState.channel(channelId);

  // Canal público continua visível após recusar; só deixa de indicar convite aberto.
  if (channel) {
    channel.pushAttributes({
      isInvited: false,
      invitedById: null,
      invitedByName: null
    });
  }
}

/**
 * Coloca um documento JSON:API de canal no store e devolve o registro. Usado por
 * todo endpoint que responde com um canal (join, accept, add members).
 */
export function adoptChannelPayload(payload) {
  var _document$data, _ref;
  const document = payload;
  if (!(document != null && (_document$data = document.data) != null && _document$data.id)) return null;
  const pushed = app.store.pushPayload(document);
  return (_ref = Array.isArray(pushed) ? pushed[0] : pushed) != null ? _ref : null;
}

/** Texto de erro da resposta do servidor, ou o fallback local quando não houver. */
export function invitationErrorText(error, fallbackKey) {
  var _error$response;
  const detail = error == null || (_error$response = error.response) == null || (_error$response = _error$response.errors) == null || (_error$response = _error$response[0]) == null ? void 0 : _error$response.detail;
  if (typeof detail === 'string' && detail !== '') return detail;
  return app.translator.trans(fallbackKey, {}, true);
}
flarum.reg.add('ramon-chat', 'forum/utils/invitations', { adoptChannelPayload: adoptChannelPayload,invitationErrorText: invitationErrorText, });